import Cookies from 'js-cookie';

function setupA11yButton() {
  const wrapper = document.querySelector('.accessibility-menu-wrapper');
  const btn = wrapper.querySelector('[data-a11y-btn]');
  const menu = document.querySelector('.accessibility-menu');

  function isMenuOpen() {
    return wrapper.classList.contains('is-menu-open') === true;
  }

  btn.addEventListener('click', (e) => {
    wrapper.classList.toggle('is-menu-open');
    menu.setAttribute('aria-hidden', String(!isMenuOpen()));
    menu.hidden = !isMenuOpen();
  });

  window.addEventListener('click', function (e) {
    const target = e.target;
    if (!target.closest('.accessibility-menu-wrapper') && isMenuOpen()) {
      // clicked outside wrapper, close
      wrapper.classList.remove('is-menu-open');
      menu.setAttribute('aria-hidden', 'true');
      menu.hidden = !isMenuOpen();
    }
  });
}

// init

const cookiePrefix = 'bh_';
const expiresHours = 24;

// text size

const zoomCookieId = cookiePrefix + 'zoom';

const decreaseTextBtns = document.querySelectorAll(
  '[data-action="decreaseText"]'
);
const increaseTextBtns = document.querySelectorAll(
  '[data-action="increaseText"]'
);
const zoomMin = 10;
const zoomMax = 13;
let zoom = Cookies.get(zoomCookieId)
  ? Number(Cookies.get(zoomCookieId))
  : zoomMin;

function applyZoom() {
  Cookies.set(zoomCookieId, zoom, { expires: expiresHours });
  document.body.style.zoom = zoom / 10;
  if (zoom === zoomMin) {
    decreaseTextBtns.forEach((el) => {
      el.disabled = true;
    });
  } else {
    decreaseTextBtns.forEach((el) => {
      el.disabled = false;
    });
  }
  if (zoom === zoomMax) {
    increaseTextBtns.forEach((el) => {
      el.disabled = true;
    });
  } else {
    increaseTextBtns.forEach((el) => {
      el.disabled = false;
    });
  }
  increaseTextBtns.forEach((el) => {
    if (zoom > zoomMin) {
      el.classList.add('is-active');
    } else {
      el.classList.remove('is-active');
    }
  });
}

increaseTextBtns.forEach((el) => {
  el.addEventListener('click', function (e) {
    zoom++;
    if (zoom > zoomMax) zoom = zoomMax;
    applyZoom();
  });
});

decreaseTextBtns.forEach((el) => {
  el.addEventListener('click', function (e) {
    zoom--;
    if (zoom < zoomMin) zoom = zoomMin;
    applyZoom();
  });
});

document.addEventListener('DOMContentLoaded', () => {
  applyZoom();
});

// desaturate

const desaturateCookieId = cookiePrefix + 'desaturate';
const desaturateBtns = document.querySelectorAll('[data-action="desaturate"]');
let desaturate = Cookies.get(desaturateCookieId) === 'true' ?? false;

function applyDesaturate() {
  if (desaturate) {
    document.documentElement.classList.add('site--desaturate');
  } else {
    document.documentElement.classList.remove('site--desaturate');
  }
  desaturateBtns.forEach((el) => {
    if (desaturate) {
      el.classList.add('is-active');
    } else {
      el.classList.remove('is-active');
    }
  });
  Cookies.set(desaturateCookieId, desaturate, { expires: expiresHours });
}

desaturateBtns.forEach((el) => {
  el.addEventListener('click', function (e) {
    desaturate = !desaturate;
    applyDesaturate();
  });
});

document.addEventListener('DOMContentLoaded', () => {
  applyDesaturate();
});

// contrast

const highContrastCookieId = cookiePrefix + 'highContrast';
const highContrastBtns = document.querySelectorAll(
  '[data-action="highContrast"]'
);
let highContrast = Cookies.get(highContrastCookieId) === 'true' ?? false;

function applyHighContrast() {
  if (highContrast) {
    document.documentElement.classList.add('site--high-contrast');
  } else {
    document.documentElement.classList.remove('site--high-contrast');
  }
  highContrastBtns.forEach((el) => {
    if (highContrast) {
      el.classList.add('is-active');
    } else {
      el.classList.remove('is-active');
    }
  });
  Cookies.set(highContrastCookieId, highContrast, { expires: expiresHours });
}

highContrastBtns.forEach((el) => {
  el.addEventListener('click', function (e) {
    highContrast = !highContrast;
    applyHighContrast();
  });
});

document.addEventListener('DOMContentLoaded', () => {
  applyHighContrast();
});

// reset

const resetBtns = document.querySelectorAll(
  '[data-action="resetAccessibility"]'
);

resetBtns.forEach((el) => {
  el.addEventListener('click', function (e) {
    desaturate = false;
    applyDesaturate();
    highContrast = false;
    applyHighContrast();
    zoom = zoomMin;
    applyZoom();
  });
});

document.addEventListener('DOMContentLoaded', function () {
  setupA11yButton();
});
